// extracted by mini-css-extract-plugin
export default {"container":"programTags_container__q1PrT"};